import type { RoleType } from '@/features/role/domain/enums/RoleType'

export class CanceledOrderMiniEntity {
  id?: string
  orderId?: string
  cancelOrderReasonId?: number
  cancelOrderReasonTitle?: string | null
  cancelerRole?: RoleType
  cancelerUserId?: string
  cancelerUserDisplayName?: string | null
  cancelerUserPhotoUrl?: string | null
  createdAt?: string
}
